
import React from "react";
import NavBarComponent from "../../components/navBar/NavBarComponent";
import FooterComponent from "../../components/home/FooterComponent";
import CheckoutComponent from "../../components/checkout/checkoutFlow/checkoutComponent";


export default function CheckoutPage() {

    return (
        <div>
            {/*<NavBarComponent />*/}
            <CheckoutComponent />
            <FooterComponent />
        </div>
    )
}